export default __webpack_public_path__ + "static/media/logout_white.49ea6b20.svg";